<np-header></np-header>

<!-- Main Content -->
<main class="container">
  <section id="column1">
    <div class="row">
      <div class="col col-12">
        <h1 class="app-title text-primary fw-bold mb-1">DrillPlan Consumption Hub</h1>
        <p class="app-subtitle text-secondary mb-0 text-center fw-bold">Trajectory Import Tool</p>
      </div>
    </div>
    
    <div class="row">
      <div class="col col-12">
        <router-outlet></router-outlet>

        <app-auth-section class="d-block mb-3"></app-auth-section>
        <app-context-section class="d-block mb-3"></app-context-section>
      </div>
    </div>
    
    <div class="row">
      <div class="col col-12">
        <app-publish-section class="d-block mb-3"></app-publish-section>
      </div>
    </div>
    
    @if (calAuth.isAdmin()) {
      <div class="row">
        <div class="col col-12">
          <app-danger-zone class="d-block mb-3"></app-danger-zone>
        </div>
      </div>
    }
  </section>
</main>

<!-- Footer -->
 <np-footer
      [contentContactUrl]="'mailto:WellsEngineeringWebDevs@chevron.com'"
      [contentContactName]="'WellsEngineeringWebDevs@chevron.com'"
      [technicalContactUrl]="'mailto:WellsEngineeringWebDevs@chevron.com'"
      [technicalContactName]="'WellsEngineeringWebDevs@chevron.com'"
      [opCoUrl]="'https://chevron.sharepoint.com/sites/DCDigital/SitePages/Design-Product-Line.aspx'"
      [opCoName]="'Wells IT'">
</np-footer>